import { render, staticRenderFns } from "./TenantGeneralSetting.vue?vue&type=template&id=86627f86&"
import script from "./TenantGeneralSetting.vue?vue&type=script&lang=js&"
export * from "./TenantGeneralSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports